/* eslint-disable */
import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "./Base";
import QueryableInterface from "@/interfaces/QueryableInterface";
import Spot from "@/models/Spot";
import WithTimeIntervals from "@/models/interfaces/WithTimeIntervals";
import qs from "qs";
import { Getter } from "vuex-class";
import AdcontrolProfile from "@/models/AdcontrolProfile";

@Component
export default class SpotsMixin extends Base {
  @Getter("profile") mixinUserProfile!: AdcontrolProfile;

  getSpots(params: QueryableInterface, tag: string): Promise<Spot[]> {
    if (this.mixinUserProfile?.slug) {
      params.profile = this.mixinUserProfile.slug;
    }

    const queryString = qs.stringify(params, { arrayFormat: "brackets" });
    const url = `${API_ENDPOINT}/spots.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }

  getSpotsDistribution(
    data: any,
    tag: string
  ): Promise<Array<Spot & WithTimeIntervals>> {
    if (this.mixinUserProfile?.slug) {
      data.profile = this.mixinUserProfile.slug;
    }
    const url = `${API_ENDPOINT}/spots/distribution.json`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "POST",
      data,
    });
  }
}
